import { Record } from 'immutable';
import * as A from '@/domain/paySettings/actions';
import { companySignInAction } from '@/domain/companies/companiesActions';
import type { PaySettingsStateData } from '@/domain/paySettings/types';
import { paymentProvidersList, payApproversList } from '@/domain/paySettings/helpers';

const initialState = Record<PaySettingsStateData>({
  isProvidersLoaded: false,
  providers: paymentProvidersList(),
  approvers: payApproversList(),
});

export const reducer = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  paySettings(state = initialState(), action: any) {
    switch (action.type) {
      case A.getProvidersAction.request:
        return state.set('isProvidersLoaded', false);

      case A.getProvidersAction.success:
        return state.set('providers', action.payload).set('isProvidersLoaded', true);

      // Another company's providers and approvers must not be reused (nor scope its permissions): the pay sagas
      // reload an empty providers list and an empty approvers list.
      case companySignInAction.success:
        return initialState();

      case A.connectProviderAction.success:
      case A.disconnectProviderAction.success:
        return state.updateIn(['providers'], (providers: any) =>
          providers.set(
            providers.findIndex((provider: any) => provider.providerName === action.payload.providerName),
            action.payload,
          ),
        );

      case A.getProviderApproversAction.success:
        return state.set('approvers', action.payload);

      default:
        return state;
    }
  },
};
